export class VideoCallRoomDTO {
  public roomName: string;

  public token: string;
}